import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericResponse, Response } from 'src/app/_models/response.model';
import { LoggedInUserResponseData } from '../_models/user-login.model';
import { IRefreshTokenDTO } from '../_interfaces/auth/i-refresh-token';
import { RSAEncryptionService } from '../helpers/rsa-encryptor';
import * as Sentry from "@sentry/angular";
@Injectable({
  providedIn: 'root',
})
export class RegisterLoginService {
  loginUrl = 'api/users/dashboard-login';
  refreshTokenUrl = 'api/Users/RefreshToken';

  constructor(
    private http: HttpClient,
    private rsaEncryptionService: RSAEncryptionService
  ) {}

  login(user): Observable<Response<LoggedInUserResponseData>> {
    let encryptedPassword = this.rsaEncryptionService.encrypt(user.password);
    const loginRequest = { ...user, password: encryptedPassword };
    return this.http.post<Response<LoggedInUserResponseData>>(
      this.loginUrl,
      loginRequest
    );
  }

  setAccessAndRefreshToken(accessToken: string, refreshToken: string) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  }

  setLoginResponseInLocalStorage(data: LoggedInUserResponseData) {
    this.setAccessAndRefreshToken(data.accessToken, data.refreshToken);
    localStorage.setItem('accountType', data.accountType);
    localStorage.setItem('email', data.email);
    localStorage.setItem('fullName', data.fullName);
    localStorage.setItem('groupId', data.groupId.toString());
    localStorage.setItem('id', data.id.toString());
    localStorage.setItem('isActive', data.isActive);
    localStorage.setItem('title', data.title);
    localStorage.setItem('phone', data.phone);
    
    // set sentry user data info
    this.setSentryUserData(data);

    let previousPermissions = localStorage.getItem('permissions');
    let currentPermissions = JSON.stringify(data.permissions);
    if (previousPermissions !== currentPermissions) {
      localStorage.setItem('permissions', JSON.stringify(data.permissions));
      window.location.reload();
    }
  }

  getAccessAndRefreshToken(): IRefreshTokenDTO {
    let tokenData: IRefreshTokenDTO = {
      accessToken: localStorage.getItem('accessToken') || '',
      refreshToken: localStorage.getItem('refreshToken') || '',
    };
    return tokenData;
  }

  refreshToken(
    tokenData: IRefreshTokenDTO
  ): Observable<GenericResponse<LoggedInUserResponseData>> {
    return this.http.put<GenericResponse<LoggedInUserResponseData>>(
      this.refreshTokenUrl,
      tokenData
    );
  }
  setSentryUserData(data: LoggedInUserResponseData) {
    Sentry.setUser({ email: data.email,  username: data.fullName, accountType: data.accountType, title: data.title });
  }
}
